import { module } from 'angular';

import bookmarkBlockComponent from './bookmark/bookmark-block.component';
import dashboardActionsBlockComponent from './dashboard-actions/dashboard-actions-block.component';
import queryBlockComponent from './query/query-block.component';
import workflowBlockComponent from './workflow/workflow-block.component';
import dashboardBlockComponent from './dashboard/dashboard-block.component';
import fastImportBlockComponent from './fast-import/fast-import-block.component';
import homeLayoutEditorComponent from './devtool/devtool.component';

export default module('app.home', [])
	.component('homeBookmarkBlock', bookmarkBlockComponent)
	.component('homeDashboardActionsBlock', dashboardActionsBlockComponent)
	.component('homeQueryBlock', queryBlockComponent)
	.component('homeWorkflowBlock', workflowBlockComponent)
	.component('homeDashboardBlock', dashboardBlockComponent)
	.component('homeFastimportBlock', fastImportBlockComponent)
	.component('homeLayoutEditor', homeLayoutEditorComponent)
	.name;
